<template>
  <div v-if="data.purchaseId" class="history contents">
    <div class="view">
      <dl class="purchaseDate">
        <dt class="accessibilityHide">구매 일시</dt>
        <dd>{{ date }}</dd>
      </dl>
      <dl class="purchaseNum">
        <dt>주문번호</dt>
        <dd>{{ data.purchaseId }}</dd>
      </dl>
      <ul class="listTypeCart">
        <li
          class="productItem"
          v-for="(product, index) in data.purchaseProductList"
          :key="index"
        >
          <list-item
            :product="product"
            :productsCount="data.purchaseProductList.length"
            @refreshDetail="refreshDetail"
          />
        </li>
      </ul>
    </div>

    <div v-if="isShippingProduct" class="deliveryInfo">
      <h2 class="subTitle">배송 정보</h2>

      <div class="postInfo">
        <ul>
          <li class="personalInfo">
            <div>
              <strong class="name">{{ deliveryInformation.receiverName }}</strong>
              <span class="phone">{{ deliveryInformation.phoneNumber }}</span>
            </div>
          </li>
          <li>
            <span>{{ `[${deliveryInformation.zipCode}]` }}</span>
            {{ deliveryInformation.address }}
          </li>
          <li>
            {{ deliveryInformation.detailAddress }}
          </li>
        </ul>

        <div class="postExtraInfo">
          <p>배송시 요청사항 :</p>
          <p class="postMessage">{{ deliveryInformation.requestInfo }}</p>
        </div>
      </div>
    </div>

    <div class="payInfo">
      <h2 class="subTitle">결제 정보</h2>
      <div v-if="this.data.purchaseProductList">
        <dl>
          <dt>총 상품 금액</dt>
          <dd>{{ productPriceObj.displayPrice.addComma() }}{{ currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>할인금액</dt>
          <dd>-{{ productPriceObj.benefit.addComma() }}{{ currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>총 결제 금액</dt>
          <dd>{{ productPriceObj.price.addComma() }}{{ currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>결제수단</dt>
          <dd>{{ data.paymentTypeName }}</dd>
        </dl>
        <button
          type="button"
          @click="handleClick"
          class="btReceipt"
          v-if="data.paymentType === 2"
        >현금영수증 발행정보 <span class="icon iconMore4"></span></button>
      </div>
    </div>
  </div>
</template>

<script>
import MyAPI from '@/api/my'
import ListItem from '@/views/my/ListItem'
import { mapActions } from 'vuex'
import { calProductsPriceObejct } from '@/utils'

export default {
  components: {
    ListItem
  },
  props: {
    purchaseId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      data: {},
      paymentType: {
        1: '카카오페이',
        2: '토스페이',
        3: 'PAYCO',
        4: '문화상품권',
        5: '신용카드'
      },
      deliveryInformation: {
        receiverName: "",
        phoneNumber: "",
        zipCode: "",
        address: "",
        detailAddress: "",
        requestInfo: ""
      },
    }
  },
  computed: {
    productPriceObj() {
      return calProductsPriceObejct(this.data.purchaseProductList)
    },
    isShippingProduct() {
      const shippingProduct = this.data.purchaseProductList.find((product) => {
        return product.type === 3 || product.type === 4
      });

      return shippingProduct !== undefined;
    },
    date() {
      return this.data.purchaseDate.substring(0, 10);
    },
    currencyUnit() {
      return this.data.purchaseProductList[0].currencyUnit
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    handleClick() {
      MyAPI.getReceipt(this.purchaseId, ({ data }) => {
        const { paymentReceipt } = data
        this.openModal({
          type: 'alert',
          header: '현금영수증 발행정보',
          message: `<table>
                      <tbody>
                          <tr>
                            <th>발행일자</th>
                            <td>${paymentReceipt.issueDate}</td>
                          </tr>
                          <tr>
                            <th>금액</th>
                            <td>${paymentReceipt.issueAmount.addComma()}원</td>
                          </tr>
                          <tr>
                            <th>결제수단</th>
                            <td>${paymentReceipt.categoryName}</td>
                          </tr>
                          <tr>
                            <th>발행승인번호</th>
                            <td>${paymentReceipt.issueNumber}</td>
                          </tr>
                      </tbody>
                    </table>
                    <p>※ 발행 현금영수증은 국세청 홈택스 페이지에서 확인 가능합니다.</p>`
        })
      })
    },
    refreshDetail() {
      MyAPI.getPurchaseDetail(this.purchaseId, responseData => {
        this.data = responseData.data;

         if(this.isShippingProduct) {
          this.deliveryInformation = responseData.data.delivery;
        }
      })
    }
  },
  mounted() {
    MyAPI.getPurchaseDetail(this.purchaseId, responseData => {
      this.data = responseData.data;

       if(this.isShippingProduct) {
        this.deliveryInformation = responseData.data.delivery;
      }
    })
  }
}
</script>

<style lang="scss">
.history {

  .subTitle {
    height: 42px;
    padding: 15px 16px 0;
    margin: 0;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 1px solid #d6d6db;
    box-sizing: border-box;
  }

  .payInfo {
    margin-top: 10px;
    background-color: #fff;
    border-bottom: 1px solid #efefef;

    div {
      padding: 14px 16px;
      text-align: right;
    }
    dl {
      display: table;
      width: 100%;
      height: 26px;
      text-align: left;
    }
    dt,
    dd {
      display: table-cell;
    }
    dt {
      font-size: 13px;
      color: #636376;
    }
    dd {
      font-size: 15px;
      text-align: right;
    }
  }
}
</style>

<style lang="scss" scoped>
.history {
  .payInfo {
    dl:nth-last-of-type(2),
    dl:nth-last-of-type(1) {
      font-weight: bold;
      dt,
      dd {
        padding-top: 13px;
        height: 26px;
      }
      dt {
        font-size: 14px;
        color: #151721;
        font-weight: normal;
      }
      dd {
        font-size: 16px;
      }
    }
    dl:nth-last-of-type(2) {
      margin-top: 3px;
      border-top: 1px solid #636376;
      dd {
        color: #6134f1;
      }
    }
    dl:nth-last-of-type(1) {
      dt,
      dd {
        padding-top: 10px;
      }
    }
    .btReceipt {
      width: 126px;
      height: 22px;
      padding-top: 1px;
      margin-top: 8px;
      font-size: 12px;
      color: #636376;
      border: 1px solid #d6d6db;
      .icon {
        margin-top: -3px;
      }
    }
  }
}
</style>
